<template>
    <page>
        <module enable-flex>
            <!--在库汇总统计-->
            <div class="stock-stat flex">
                <div class="item flex-grow item-blue">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">在库数量：</span>
                            <span class="amount">{{ summary.total_count || 0 }}</span>
                        </div>
                    </div>
                </div>
                <div class="item flex-grow item-orange">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">采购总金额：</span>
                            <span class="amount">￥{{ summary.purchase_money || '0.00' }}</span>
                        </div>
                    </div>
                </div>
                <div class="item flex-grow item-red">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">维修总成本：</span>
                            <span class="amount">￥{{ summary.repair_money || '0.00' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <view-list ref="view" class="flex-grow" :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="采购单号">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
                        </m-search-item>
                        <m-search-item label="采购员">
                            <c-input name="purchase_user_name" placeholder="请输入采购员"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select name="level_type" :options="LEVEL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="入库时间" colspan="2">
                            <c-datetime range start-name="stock_in_start_date" end-name="stock_in_end_date"></c-datetime>
                        </m-search-item>
                        <m-search-item label="操作部门">
                            <c-input name="operate_department"></c-input>
                        </m-search-item>
                        <m-search-item label="操作人">
                            <c-input name="operate_user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="供应部门">
                            <c-input name="purchase_department"></c-input>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button color="main" v-if="auth('b_storage_transfer')" prepend-icon="tf-transfer" @click="codeTransfer()">批量调拨</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_in')" prepend-icon="tf-return-stock" @click="codeReturn()">批量确认返库</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_confirm_reject')" prepend-icon="tf-return-stock" @click="confirmReject()">批量同意驳回</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_apply')" prepend-icon="tf-return-goods" @click="purchaseOutReturn(1)">批量申请退库</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_confirm')" prepend-icon="tf-accept" @click="purchaseOutReturn(2)">批量确认退库</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_confirm')" prepend-icon="tf-cancel" @click="purchaseOutReturn(3)">批量取消退库</c-button>
                    <c-button v-if="auth('b_storage_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--多选后操作栏切换为批量模式：显示已选条数并可取消勾选，按钮与常态操作栏保持一致-->
                <template #batchOperate>
                    <c-button color="main" v-if="auth('b_storage_transfer')" prepend-icon="tf-transfer" @click="codeTransfer()">批量调拨</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_in')" prepend-icon="tf-return-stock" @click="codeReturn()">批量确认返库</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_confirm_reject')" prepend-icon="tf-return-stock" @click="confirmReject()">批量同意驳回</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_apply')" prepend-icon="tf-return-goods" @click="purchaseOutReturn(1)">批量申请退库</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_confirm')" prepend-icon="tf-accept" @click="purchaseOutReturn(2)">批量确认退库</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_confirm')" prepend-icon="tf-cancel" @click="purchaseOutReturn(3)">批量取消退库</c-button>
                    <c-button v-if="auth('b_storage_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--商品信息-->
                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--关联单据-->
                <template #purchase_code="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购单：{{data.purchase_code}}</p>
                        <p class="m-product-info-name">三方订单号：{{data.out_order_number}}</p>
                    </div>
                </template>
                <!--价格信息-->
                <template #purchase_price="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购：￥{{data.purchase_price||0}}</p>
                        <p class="m-product-info-name">维修：￥{{data.repair_cost||0}}</p>
                    </div>
                </template>
                <!--是否拆机（拆机商品悬停按背贴码查询拆机订单：下单时间+拆机项明细）-->
                <template #is_dismantle="{data}">
                    <c-tooltip v-if="data.is_dismantle==1" position="bottom" color="white" @mouseenter.native="loadDismantleOrders(data)">
                        <span class="m-dismantle-tag">拆</span>
                        <template #tip>
                            <p v-if="getDismantleState(data).loading" class="m-dismantle-item">正在查询拆机订单...</p>
                            <p v-else-if="getDismantleState(data).error" class="m-dismantle-item">{{getDismantleState(data).error}}</p>
                            <template v-else>
                                <p v-for="(order, index) in getDismantleState(data).orders" :key="index" class="m-dismantle-item">{{formatDismantleDate(order.create_date)}}&nbsp;&nbsp;{{order.items.join('、')}}</p>
                                <p v-if="!getDismantleState(data).orders.length" class="m-dismantle-item">暂无拆机记录</p>
                            </template>
                        </template>
                    </c-tooltip>
                    <span v-else>-</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_storage_transfer')" :disabled="data.state!=10" icon="tf-transfer" @click="codeTransfer(data)">调拨</c-table-button>
                        <c-table-button v-if="auth('b_storage_in')" icon="tf-return-stock" @click="codeReturn(data)" :disabled="!(data.state == 13||data.state == 14 || data.state == 23||data.state ==24 || data.state == 33||data.state ==34)">确认返库</c-table-button>
                        <c-table-button v-if="auth('b_storage_confirm_reject')" :disabled="!data.buttons?.confirm_reject?.visible" icon="tf-accept" @click="confirmReject(data)">同意驳回</c-table-button>
                        <c-table-button v-if="auth('b_storage_remark_view')" icon="tf-detail" @click="showRemark(data)">查看备注</c-table-button>
                        <c-table-button v-if="auth('b_storage_out_apply') && data.state != 35" :disabled="data.state!=10" icon="tf-return-goods" @click="purchaseOutReturn(1,data)">申请退库</c-table-button>
                        <c-table-button v-if="auth('b_storage_out_confirm') && data.state == 35" icon="tf-accept" @click="purchaseOutReturn(2,data)">确认退库</c-table-button>
                        <c-table-button v-if="auth('b_storage_out_confirm') && data.state == 35" icon="tf-cancel" @click="purchaseOutReturn(3,data)">取消退库</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--调拨弹窗-->
            <code-transfer ref="codeTransfer" @resolve="refresh"></code-transfer>
            <!--调拨返库弹窗-->
            <code-return ref="codeReturn" @resolve="refresh"></code-return>
            <!--采购退库申请弹窗-->
            <code-purchase-out ref="codePurchaseOut" @resolve="refresh"></code-purchase-out>
            <!--查看备注弹窗-->
            <code-remark ref="codeRemark"></code-remark>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeTransfer from "@/pages/storage/code_transfer.vue";
import codeReturn from "@/pages/storage/code_returne.vue";
import codePurchaseOut from "@/pages/storage/code_purchase_out.vue";
import codeRemark from "@/pages/storage/code_remark.vue";
import handoverReject from '@/mixins/handover_reject';

export default {
    name: 'm_wait_storage',

    mixins: [handoverReject],
    handoverModuleType: 0,

    components: {codeTransfer,codeReturn,codePurchaseOut,codeRemark},

    computed: {
        ...asyncMapState(['LEVEL_TYPE', 'DISMANTLE_ITEM']),
        ...mapState(['saasInfo']),

    },

    data() {
        return {
            defaultSearchData: {
            },
            workType: 22,
            /**在库全量汇总（数量/采购总金额/维修总成本，不受视图与搜索条件限制） */
            summary: {},
            /**是否拆机列悬停拆机订单查询状态：key=背贴码，结果 60s 内复用，避免反复悬停重复请求 */
            dismantleMap: {},
            /**悬停防抖定时器：鼠标快速划过列表时不逐个触发接口 */
            dismantleTimer: null
        }
    },
    mounted() {
        this.loadSummary();
    },
    beforeDestroy() {
        if (this.dismantleTimer) clearTimeout(this.dismantleTimer);
    },
    methods: {

        /*********加载在库全量汇总统计（全部在库数据，不随视图/搜索条件变化）**********/
        loadSummary() {
            this.request({
                url: '/storage/instock/summary',
                data: {},
                loading: false,
                success: res => {
                    this.summary = res || {};
                }
            });
        },

        /*********业务操作完成后刷新列表与全量统计**********/
        refresh() {
            this.$refs.view.update();
            this.loadSummary();
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },

        /*********悬停是否拆机列：叠停 200ms 才发起查询，结果 60s 内复用，避免鼠标划过列表时批量打接口**********/
        loadDismantleOrders(data) {
            if (data.is_dismantle != 1) return;
            var key = data.produce_unique_code;
            var state = this.dismantleMap[key];
            // 在途请求未返回前不重复发起，避免鼠标移动抖动产生并发查询
            if (state && state.loading) return;
            // 已有结果（含失败结果）的短时缓存：同一行反复悬停不再重复查询
            if (state && (Date.now() - (state.time || 0) < 60000)) return;
            if (this.dismantleTimer) clearTimeout(this.dismantleTimer);
            this.dismantleTimer = setTimeout(function () {
                this.fetchDismantleOrders(key);
            }.bind(this), 200);
        },

        /*********实际发起拆机订单查询（已经过悬停防抖）**********/
        fetchDismantleOrders(key) {
            this.$set(this.dismantleMap, key, {
                loading: true,
                error: '',
                orders: [],
                time: 0
            });
            this.request({
                url: '/offline/sale/order/dismantleOrders',
                data: {
                    produce_code: key
                },
                fail: (code, obj, msg) => {
                    // 悬停查询失败不弹全局提示，错误信息在浮层内展示
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: msg || '拆机订单查询失败',
                        orders: [],
                        time: Date.now()
                    });
                    return false;
                },
                success: result => {
                    // 每笔拆机订单浮层一行：下单时间+拆机项名称列表
                    var orders = ((result && result.orders) || []).map(order => {
                        return {
                            create_date: order.create_date,
                            items: this.formatDismantleItems(order.dismantle_items)
                        };
                    });
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: '',
                        orders: orders,
                        time: Date.now()
                    });
                }
            });
        },

        /*********获取当前行拆机订单浮层状态（查询中/失败/订单列表）**********/
        getDismantleState(data) {
            var state = this.dismantleMap[data.produce_unique_code] || {};
            return {
                loading: !!state.loading,
                error: state.error || '',
                orders: state.orders || []
            };
        },

        /*********解析拆机项并按字典翻译显示名称（存储为字典value数组，与开单页口径一致）**********/
        formatDismantleItems(value) {
            if (!value) return [];
            var list = value;
            if (typeof list == 'string') {
                try {
                    list = JSON.parse(list);
                } catch (e) {
                    return [value];
                }
            }
            if (!Array.isArray(list)) return [];
            var dict = this.DISMANTLE_ITEM || [];
            return list.map(item => {
                // 数组项为字典value或{value,name}对象，统一取value后翻译为字典名称展示
                var val = String(item && item.value ? item.value : item);
                var option = dict.find(dic => String(dic.value) == val);
                return option ? option.name : val;
            }).filter(item => item);
        },

        /*********拆机订单下单时间格式化（设计图展示到日）**********/
        formatDismantleDate(value) {
            if (!value) return '-';
            // 后端返回完整时间字符串，取日期部分展示
            return String(value).slice(0, 10);
        },
        /**
         * 调拨
         */
        codeTransfer(data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                list.forEach(item => {
                    if (item.state!=10){
                        this.$message({
                            message: '【在库】状态的背贴码才能进行调拨操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                        return
                    }
                });
            }
            if (flag){
                this.$refs.codeTransfer.open(list);
            }
        },
        /*
        * 返库
        * */
        codeReturn(data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                list.forEach(item => {
                    if (!(item.state == 13 || item.state == 14 || item.state == 23 || item.state ==24 || item.state == 33 || item.state ==34)){
                        this.$message({
                            message: '只能选择【返库中】的商品进行【返库】操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                        return
                    }
                });
            }
            if (flag){
                this.$refs.codeReturn.open(list);
            }
        },
        /**
         * @param type  1=申请退库  2=确认退库 3：取消退库
         * @param data  退库数据
         */
        purchaseOutReturn(type,data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                if (type == 1){
                    list.forEach(item => {
                        if (item.state!=10){
                            this.$message({
                                message: '【在库】状态的背贴码才能进行“退库申请”操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                }else if (type == 2){
                    list.forEach(item => {
                        if (item.state!=35){
                            this.$message({
                                message: '【待退库】状态的背贴码才能进行“确认退库”操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                }else {
                    list.forEach(item => {
                        if (item.state!=35){
                            this.$message({
                                message: '【待退库】状态的背贴码才能进行“取消退库”操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                }
            }
            if (flag){
                this.$refs.codePurchaseOut.open(type,list);
            }
        },
        /****展示备注****/
        showRemark(data) {
            this.$refs.codeRemark.open(data);
        }
    }
}
</script>
<style lang="stylus" scoped>
.stock-stat {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 12px 16px 2px;

    .item {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        max-width: 550px;
        padding: 12px 20px 14px;
        border-radius: 8px;
        color: #fff;

        &.item-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.item-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.item-red {
            background: linear-gradient(90deg, #dc2626, #ef4444);
        }

        .info {
            .title-row {
                display: flex;
                line-height: 32px;

                .title {
                    font-size: 13px;
                    opacity: 0.95;
                }

                .amount {
                    font-size: 24px;
                    font-weight: bold;
                }
            }
        }
    }
}

.m-product-info {
    line-height: 20px;
    font-size: 13px;
    color: #333;

    .m-product-info-name {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .m-product-info-code {
        color: #999;
        font-size: 12px;
    }
}

// 批量生成发货单预览
.m-batch-preview-body {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.m-batch-preview {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding-right: 4px;

    .m-preview-group {
        background: #f7f8fa;
        border-radius: 4px;
        padding: 12px 16px;
        margin-bottom: 12px;

        .m-preview-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;

            .m-preview-badge {
                padding: 2px 6px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;

                &.m-merge {
                    background: #3D5EFF;
                }

                &.m-single {
                    background: #07B461;
                }
            }

            .m-preview-receiver {
                flex: 1;
                font-size: 13px;
                color: #333;
                word-break: break-all;
            }

            .m-preview-total {
                font-size: 13px;
                color: #666;
                white-space: nowrap;
            }
        }

        .m-preview-orders {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .m-preview-order {
                background: #fff;
                border: 1px solid #e5e5e5;
                border-radius: 4px;
                padding: 6px 10px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                color: #333;

                .m-preview-order-text {
                    word-break: break-all;
                }

                .m-preview-split {
                    color: #3D5EFF;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    flex-shrink: 0;

                    i {
                        font-size: 14px;
                        font-style: normal;
                    }

                    &:hover {
                        color: #5F7FFF;
                    }
                }
            }
        }
    }

    .m-preview-empty {
        text-align: center;
        color: #999;
        padding: 30px 0;
        font-size: 13px;
    }
}

.m-preview-footer {
    margin-top: 16px;
    font-size: 13px;
    color: #666;
}
.m-dismantle-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1.5px solid #ed3f14;
    border-radius: 50%;
    color: #ed3f14;
    font-size: 13px;
    font-weight: bold;
}

/* 是否拆机列悬停浮层：每行=下单时间+拆机项明细 */
.m-dismantle-item {
    margin: 0;
    line-height: 20px;
    white-space: nowrap;
}
</style>
